module.exports = __webpack_public_path__ + "media/images/prev-cd032b50.svg";